module.exports = __webpack_public_path__ + "img/rightArrow.fad2a96d.svg";